// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Baloo+2:wght@400..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` /* Application web codée en React par Noé LAROCHE pour EnerVivo
 Pour toute question ou renseignement : laroche.noe@orange.fr*/

html, body {
  height: 100%;
  margin: 0;
  padding: 0;
  background-color: #FDFCF4; 
}

.home-container {
  display: flex;
  flex-direction: row; 
  height: 100vh;
  background-color: #FDFCF4;
}

.left-container,
.right-container {
  flex: 1 1; 
  padding: 20px;
  display: flex;
  flex-direction: column; 
  justify-content: flex-start;
  height: 100vh; 
  background-color: #FDFCF4; 
  object-fit: cover;
  background-attachment: fixed;
}

.left-image {
  width: 47%;
  height:100vh;
  object-fit: cover;
  position:fixed;
}

  .map {
    width: 100%;
    height:100vh;
  }
    
  .home-image {
    
    width: 100%; 
    height: 100%; 
    object-fit: cover;
  }


  .image-banner {
    width: 100%; 
    height: 20%; 
    display: flex;
    flex-direction: column;
    align-items: center; 
    justify-content: flex-start;
    margin-bottom: 20px;
  }
  
  .banner-image {
    width: 50%; 
    height: 80%; 
    object-fit: contain;
  }

  .text-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
  }
  
  .next-button {
    background-color: #1C7862; 
    color: white; 
    font-family: 'Baloo 2', sans-serif;
    font-weight: bold; 
    border: none; 
    padding: 10px 20px; 
    font-size: 16px; 
    cursor: pointer; 
    border-radius: 10px;
    margin-top: 20px;
    width: 33%; 
    max-width: 200px; 
    min-width: 150px;
    margin: 0 auto; 

  }

  .previous-button {
    background-color: #ffffff; 
    color: #1C7862;
    font-family: 'Baloo 2', sans-serif;
    font-weight: bold; 
    border: hsl(from color h s l);
    padding: 10px 20px;
    font-size: 16px;
    cursor: pointer;
    border-radius: 10px;
    margin-top: 20px;
    width: 33%; 
    max-width: 200px;
    min-width: 150px;
    margin: 0 auto;
  }
  
  .next-button:hover {
    background-color: #00B685;
  }

  .position_boutons_p2 {
    display: inline-flex;
    justify-content: space-around;
  }

  .address-bloc {
    padding: 10px;
    cursor: pointer;
  }
  
  .address-bloc:hover {
    background-color: #f0f0f0;
  }
  
  .no-suggestion {
    padding: 10px;
    color: #999;
  }

  h1 {
    align-self: center;
    font-family: 'Baloo 2', sans-serif;
    font-weight: bold;
    font-size: 40px;
    color: #1C7862
  }
  
  h2 {
    font-family: 'Montserrat', sans-serif;
    font-weight: normal;
    font-size: medium;
    margin-left: 10%;
    margin-right: 10%;
  }
  

  h3 {
    font-family: 'Montserrat', sans-serif;
    font-weight: bold;
    font-size: medium;
    margin-left: 150px;
    margin-right: 150px;
  }


  textarea.form-control {
    min-height: calc(1.2em + .75rem + var(--bs-border-width)*2);
  }

  .suggestions-container {
    width: 100%;
    margin-top: 5px;
    border: 1px solid #ccc;
    border-radius: 10px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    max-height: 200px;
    z-index: 10;
    position: absolute;
    background-color: #fff; 
  }

  .addressbar {
    display: flex;
    justify-content: left;
    width: 100%;
    padding: 5px;
    margin: 5px 0;
    font-size: 14px;
    color: #333;
    cursor: pointer;
  }

  .addressbar:hover {
    background-color: #f0f0f0; 
  }

  .address-container {
    width: 90%;
    margin-left: 20%;
    margin-right: 20%;
    align-self: center;
  }

  .addressbar-input {
      width: 100%;
      align-self: center;
      padding: 10px 15px;
      border: 2px solid #1C7862;
      border-radius: 20px;
      font-size: 16px;
      outline: none;
      background-color: #f9f9f9;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    }  
  
  .surf_parcelles {
    border: 2px solid #1C7862;
    border-radius: 10px; 
    padding: 10px; 
    background-color: #f9f9f9; 
    color: #1C7862; 
    font-size: 16px; 
    text-align: center;
    width: fit-content;
    margin: 10px auto;
  }

  .num_parcelles {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 20px;
    margin: 20px 0;
    width: 100%; /* ou une valeur fixe comme 600px */
    max-width: 800px; /* Limite la largeur si nécessaire */
  }

  
  .parcelle_container {
    border: 2px solid #1C7862;
    border-radius: 5px; 
    padding: 10px 15px;
    font-size: 16px;
    font-weight: bold; 
    color: #ffffff;
    background-color: #1C7862;
    text-align: center;
    width: 70%;
  }

  .button-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    padding: 20px;
}

button {
  width:90%;
  background-color: white;
  border: 2px solid #1C7862; 
  color: #1C7862;
  padding: 10px 20px;
  border-radius: 50px;
  font-size: 16px;
  cursor: pointer;
  text-align: center;
  transition: all 0.3s ease;
}

.form-container {
  display: flex;
  flex-wrap: wrap; 
  gap: 20px; 
  justify-content: space-between;
}

.input-group {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(50% - 20px); 
  min-width: 300px; 
}

.input-group input {
  width: 90%; 
  padding: 10px;
  border: 1px solid #0A683E;
  border-radius: 20px;
  outline: none;
  font-size: 16px;
}

.input-group select {
  width: 90%; 
  padding: 10px;
  border: 1px solid #0A683E;
  border-radius: 20px;
  outline: none;
  font-size: 16px;
}

.hiddenmap {
  display: none;
}


.input-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  font-size: 14px;
  color: #0A683E;
}


@media (max-width: 768px) {
  .input-group {
      flex: 1 1 100%; 
  }
  .home-container {
    flex-direction: column; 
  }

  .left-container {
    order: 2; 
    margin-bottom: 20px; 
  }

  .right-container {
    order: 1;
  }
}

.error-message {
  color: rgb(255, 139, 24);
  font-size: 0.9rem; 
  font-weight: bold;
  margin-top: 10px;
  text-align: center;
  background-color: #f8e7d7; 
  border: 1px solid #f9d3b0; 
  border-radius: 5px; 
  padding: 10px; 
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}

.confidentiel {
  font-size: 8px;
  margin-top: 20px;
}

.icon-button {
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 1px;
  width:25%
}

.icon-text {
  color: red;
  font-size: 24px; /* Ajustez la taille selon vos besoins */
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/Main.css"],"names":[],"mappings":"CAAC;8DAC6D;;AAE9D;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;;EAEE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;EAEE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;;EAGA;IACE,WAAW;IACX,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,kCAAkC;IAClC,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;;EAEhB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,kCAAkC;IAClC,iBAAiB;IACjB,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,oBAAoB;IACpB,6BAA6B;EAC/B;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAIA;IACE,kBAAkB;IAClB,kCAAkC;IAClC,iBAAiB;IACjB,eAAe;IACf;EACF;;EAEA;IACE,qCAAqC;IACrC,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;EACnB;;;EAGA;IACE,qCAAqC;IACrC,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;;;EAGA;IACE,2DAA2D;EAC7D;;EAEA;IACE,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,mBAAmB;IACnB,wCAAwC;IACxC,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,eAAe;IACf,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;MACI,WAAW;MACX,kBAAkB;MAClB,kBAAkB;MAClB,yBAAyB;MACzB,mBAAmB;MACnB,eAAe;MACf,aAAa;MACb,yBAAyB;MACzB,wCAAwC;IAC1C;;EAEF;IACE,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,cAAc;IACd,WAAW,EAAE,mCAAmC;IAChD,gBAAgB,EAAE,oCAAoC;EACxD;;;EAGA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,aAAa;AACjB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;;AAGA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;;AAGA;EACE;MACI,cAAc;EAClB;EACA;IACE,sBAAsB;EACxB;;EAEA;IACE,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,YAAY;EACZ;AACF;;AAEA;EACE,UAAU;EACV,eAAe,EAAE,wCAAwC;EACzD,iBAAiB;AACnB","sourcesContent":[" /* Application web codée en React par Noé LAROCHE pour EnerVivo\r\n Pour toute question ou renseignement : laroche.noe@orange.fr*/\r\n\r\nhtml, body {\r\n  height: 100%;\r\n  margin: 0;\r\n  padding: 0;\r\n  background-color: #FDFCF4; \r\n}\r\n\r\n.home-container {\r\n  display: flex;\r\n  flex-direction: row; \r\n  height: 100vh;\r\n  background-color: #FDFCF4;\r\n}\r\n\r\n.left-container,\r\n.right-container {\r\n  flex: 1; \r\n  padding: 20px;\r\n  display: flex;\r\n  flex-direction: column; \r\n  justify-content: flex-start;\r\n  height: 100vh; \r\n  background-color: #FDFCF4; \r\n  object-fit: cover;\r\n  background-attachment: fixed;\r\n}\r\n\r\n.left-image {\r\n  width: 47%;\r\n  height:100vh;\r\n  object-fit: cover;\r\n  position:fixed;\r\n}\r\n\r\n  .map {\r\n    width: 100%;\r\n    height:100vh;\r\n  }\r\n    \r\n  .home-image {\r\n    \r\n    width: 100%; \r\n    height: 100%; \r\n    object-fit: cover;\r\n  }\r\n\r\n\r\n  .image-banner {\r\n    width: 100%; \r\n    height: 20%; \r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center; \r\n    justify-content: flex-start;\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .banner-image {\r\n    width: 50%; \r\n    height: 80%; \r\n    object-fit: contain;\r\n  }\r\n\r\n  .text-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    text-align: center;\r\n  }\r\n  \r\n  .next-button {\r\n    background-color: #1C7862; \r\n    color: white; \r\n    font-family: 'Baloo 2', sans-serif;\r\n    font-weight: bold; \r\n    border: none; \r\n    padding: 10px 20px; \r\n    font-size: 16px; \r\n    cursor: pointer; \r\n    border-radius: 10px;\r\n    margin-top: 20px;\r\n    width: 33%; \r\n    max-width: 200px; \r\n    min-width: 150px;\r\n    margin: 0 auto; \r\n\r\n  }\r\n\r\n  .previous-button {\r\n    background-color: #ffffff; \r\n    color: #1C7862;\r\n    font-family: 'Baloo 2', sans-serif;\r\n    font-weight: bold; \r\n    border: hsl(from color h s l);\r\n    padding: 10px 20px;\r\n    font-size: 16px;\r\n    cursor: pointer;\r\n    border-radius: 10px;\r\n    margin-top: 20px;\r\n    width: 33%; \r\n    max-width: 200px;\r\n    min-width: 150px;\r\n    margin: 0 auto;\r\n  }\r\n  \r\n  .next-button:hover {\r\n    background-color: #00B685;\r\n  }\r\n\r\n  .position_boutons_p2 {\r\n    display: inline-flex;\r\n    justify-content: space-around;\r\n  }\r\n\r\n  .address-bloc {\r\n    padding: 10px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .address-bloc:hover {\r\n    background-color: #f0f0f0;\r\n  }\r\n  \r\n  .no-suggestion {\r\n    padding: 10px;\r\n    color: #999;\r\n  }\r\n  \r\n  @import url('https://fonts.googleapis.com/css2?family=Baloo+2:wght@400..800&display=swap');\r\n\r\n  h1 {\r\n    align-self: center;\r\n    font-family: 'Baloo 2', sans-serif;\r\n    font-weight: bold;\r\n    font-size: 40px;\r\n    color: #1C7862\r\n  }\r\n  \r\n  h2 {\r\n    font-family: 'Montserrat', sans-serif;\r\n    font-weight: normal;\r\n    font-size: medium;\r\n    margin-left: 10%;\r\n    margin-right: 10%;\r\n  }\r\n  \r\n\r\n  h3 {\r\n    font-family: 'Montserrat', sans-serif;\r\n    font-weight: bold;\r\n    font-size: medium;\r\n    margin-left: 150px;\r\n    margin-right: 150px;\r\n  }\r\n\r\n\r\n  textarea.form-control {\r\n    min-height: calc(1.2em + .75rem + var(--bs-border-width)*2);\r\n  }\r\n\r\n  .suggestions-container {\r\n    width: 100%;\r\n    margin-top: 5px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 10px;\r\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n    max-height: 200px;\r\n    z-index: 10;\r\n    position: absolute;\r\n    background-color: #fff; \r\n  }\r\n\r\n  .addressbar {\r\n    display: flex;\r\n    justify-content: left;\r\n    width: 100%;\r\n    padding: 5px;\r\n    margin: 5px 0;\r\n    font-size: 14px;\r\n    color: #333;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .addressbar:hover {\r\n    background-color: #f0f0f0; \r\n  }\r\n\r\n  .address-container {\r\n    width: 90%;\r\n    margin-left: 20%;\r\n    margin-right: 20%;\r\n    align-self: center;\r\n  }\r\n\r\n  .addressbar-input {\r\n      width: 100%;\r\n      align-self: center;\r\n      padding: 10px 15px;\r\n      border: 2px solid #1C7862;\r\n      border-radius: 20px;\r\n      font-size: 16px;\r\n      outline: none;\r\n      background-color: #f9f9f9;\r\n      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n    }  \r\n  \r\n  .surf_parcelles {\r\n    border: 2px solid #1C7862;\r\n    border-radius: 10px; \r\n    padding: 10px; \r\n    background-color: #f9f9f9; \r\n    color: #1C7862; \r\n    font-size: 16px; \r\n    text-align: center;\r\n    width: fit-content;\r\n    margin: 10px auto;\r\n  }\r\n\r\n  .num_parcelles {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 20px;\r\n    margin: 20px 0;\r\n    width: 100%; /* ou une valeur fixe comme 600px */\r\n    max-width: 800px; /* Limite la largeur si nécessaire */\r\n  }\r\n\r\n  \r\n  .parcelle_container {\r\n    border: 2px solid #1C7862;\r\n    border-radius: 5px; \r\n    padding: 10px 15px;\r\n    font-size: 16px;\r\n    font-weight: bold; \r\n    color: #ffffff;\r\n    background-color: #1C7862;\r\n    text-align: center;\r\n    width: 70%;\r\n  }\r\n\r\n  .button-container {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, 1fr);\r\n    gap: 10px;\r\n    padding: 20px;\r\n}\r\n\r\nbutton {\r\n  width:90%;\r\n  background-color: white;\r\n  border: 2px solid #1C7862; \r\n  color: #1C7862;\r\n  padding: 10px 20px;\r\n  border-radius: 50px;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n  text-align: center;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.form-container {\r\n  display: flex;\r\n  flex-wrap: wrap; \r\n  gap: 20px; \r\n  justify-content: space-between;\r\n}\r\n\r\n.input-group {\r\n  flex: 1 1 calc(50% - 20px); \r\n  min-width: 300px; \r\n}\r\n\r\n.input-group input {\r\n  width: 90%; \r\n  padding: 10px;\r\n  border: 1px solid #0A683E;\r\n  border-radius: 20px;\r\n  outline: none;\r\n  font-size: 16px;\r\n}\r\n\r\n.input-group select {\r\n  width: 90%; \r\n  padding: 10px;\r\n  border: 1px solid #0A683E;\r\n  border-radius: 20px;\r\n  outline: none;\r\n  font-size: 16px;\r\n}\r\n\r\n.hiddenmap {\r\n  display: none;\r\n}\r\n\r\n\r\n.input-group label {\r\n  display: block;\r\n  margin-bottom: 5px;\r\n  font-weight: bold;\r\n  font-size: 14px;\r\n  color: #0A683E;\r\n}\r\n\r\n\r\n@media (max-width: 768px) {\r\n  .input-group {\r\n      flex: 1 1 100%; \r\n  }\r\n  .home-container {\r\n    flex-direction: column; \r\n  }\r\n\r\n  .left-container {\r\n    order: 2; \r\n    margin-bottom: 20px; \r\n  }\r\n\r\n  .right-container {\r\n    order: 1;\r\n  }\r\n}\r\n\r\n.error-message {\r\n  color: rgb(255, 139, 24);\r\n  font-size: 0.9rem; \r\n  font-weight: bold;\r\n  margin-top: 10px;\r\n  text-align: center;\r\n  background-color: #f8e7d7; \r\n  border: 1px solid #f9d3b0; \r\n  border-radius: 5px; \r\n  padding: 10px; \r\n  max-width: 400px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n.confidentiel {\r\n  font-size: 8px;\r\n  margin-top: 20px;\r\n}\r\n\r\n.icon-button {\r\n  background-color: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 1px;\r\n  width:25%\r\n}\r\n\r\n.icon-text {\r\n  color: red;\r\n  font-size: 24px; /* Ajustez la taille selon vos besoins */\r\n  font-weight: bold;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
